import { Injectable } from '@angular/core';
import {
  CountType,
  CouponResponse,
  CustomerLTVData,
  CustomerLTVResponse,
  DataResponse,
  PeriodicElement,
} from '../interface/coupons-interface';
import { ChartConfiguration } from 'chart.js';
import { APP_CONFIG } from 'src/_config/config';

@Injectable({
  providedIn: 'root',
})
export class SetLabelAndDataService {
  constructor() {}

  setBarDataService(
    state: CouponResponse,
    barThickness?: number | null,
    borderRadius?: number | null
  ): ChartConfiguration<'bar'>['data'] {
    const extraData = state.data.total - APP_CONFIG.backgroundColors.length;
    let allBackgroundColors = APP_CONFIG.backgroundColors;

    if (extraData) {
      for (var i = 0; i < extraData; i++) {
        allBackgroundColors.push(this.getRandomColor());
      }
    }

    let barData: any = {
      labels: [],
      datasets: [
        {
          data: [],
        },
      ],
    };

    barData.labels = state?.data?.coupons?.map((item: CountType) => item.label);
    barData.datasets = [
      {
        data: [
          ...state?.data?.coupons?.map((item: CountType) => {
            if (item.hasOwnProperty('value')) {
              return (+Number(item['value'])).toFixed(2);
            }

            return null;
          }),
        ],
        barThickness,
        borderRadius,
        backgroundColor: allBackgroundColors,
      },
    ];

    return barData;
  }

  setDoughnutData(
    state: CouponResponse
  ): ChartConfiguration<'doughnut'>['data'] {
    const extraData = state.data.total - APP_CONFIG.backgroundColors.length;
    let allBackgroundColors = APP_CONFIG.backgroundColors;

    if (extraData) {
      for (var i = 0; i < extraData; i++) {
        allBackgroundColors.push(this.getRandomColor());
      }
    }

    let doughnutValue: any = {
      labels: [],
      datasets: [{ data: [], backgroundColor: [] }],
    };
    doughnutValue.labels = [
      ...state?.data?.coupons.map((item: CountType) => item.label),
    ];
    doughnutValue.datasets = [
      {
        data: [
          ...[...state?.data?.coupons.map((item: CountType) => (+Number(item.value)).toFixed(2))],
        ],
        backgroundColor: allBackgroundColors,
      },
    ];

    return doughnutValue;
  }

  setData(
    state: DataResponse,
    barThickness = 20,
    borderRadius = 10
  ): ChartConfiguration<'line'>['data'] | void {
    const extraData = state.data.total - APP_CONFIG.backgroundColors.length;
    let allBackgroundColors = APP_CONFIG.backgroundColors;

    if (extraData > 0) {
      for (let i = 0; i < extraData; i++) {
        allBackgroundColors.push(this.getRandomColor());
      }
    }

    let barData: any = {
      labels: [],
      datasets: [],
    };
    const items = state?.data?.coupons;
    const metrics = (Object.values(items)?.[0] as unknown as []).map(item => (item as any).label);

    barData.labels = Object.keys(items).map((label: string) => label);

    metrics.forEach((metric: string, index: number) => {
      barData.datasets.push({
        label: metric,
        barThickness,
        borderRadius,
        backgroundColor: allBackgroundColors[index],
        borderColor: allBackgroundColors[index],
        data: [],
      })
    })

    Object.keys(items).map((mainKey: any) => {
      const itemValues = items[mainKey];

      (itemValues as unknown as []).forEach(item => {
        barData.datasets.forEach((dataset: any) => {
          if ((item as any).label === dataset.label) {
            dataset.data.push(+Number((item as any).value).toFixed(2));
          }
        })
      });
    });

    return barData;
  }

  setCustomerLTVbyCouponType(state: CustomerLTVResponse): PeriodicElement[] {
    return state?.data?.coupons?.map((item: CustomerLTVData) => ({
      couponType: item.name,
      averageLTV: +Number(item.customerLTV).toFixed(2),
      totalCustomers: +Number(item.users),
      averageRevenue: +Number(item.valueUserAvg).toFixed(2),
    }));
  }

  getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';

    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }

    return color;
  }
}
